export interface ArbitroTranslations {
  TABLE: {
      NAME: string;
      LAST_NAME: string;
      NATIONALITY: string;
      VALIDADO: string;
      ACTIVO: string;
      EMAIL: string;
      ES_ARBITRO: string;
      ES_REPRESENTANTE: string;
      ACTIONS: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const arbitroTranslations: { [language: string]: ArbitroTranslations } = {
    en: {
        TABLE: {
            NAME: "Name",
            LAST_NAME: "Surname",
            NATIONALITY: "Nationality",
            VALIDADO: "Validated",
            ACTIVO: "Active",
            EMAIL: "Email",
            ES_ARBITRO: "Arbitrator",
            ES_REPRESENTANTE: "Representative",
            ACTIONS: "Actions",
        },
    },
    es: {
        TABLE: {
            NAME: "Nombre",
            LAST_NAME: "Apellidos",
            NATIONALITY: "Nacionalidad",
            VALIDADO: "Validado",
            ACTIVO: "Activo",
            EMAIL: "Email",
            ES_ARBITRO: "Árbitro",
            ES_REPRESENTANTE: "Representante",
            ACTIONS: "Acciones",
        },
    }
};
